
import { defineComponent, onMounted, onUpdated, ref, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { ToggleComponent } from "../../assets/ts/components/_ToggleComponent";
import { MenuComponent } from "../../assets/ts/components/MenuComponent";
import KTMenu from "./Menu.vue";
import { asideTheme } from "../../core/helpers/config";
import { ApiBase } from "../../core/api";
import { Actions } from "@/store/enums/StoreEnums";

interface WorkspaceApp {
  app_id: number | string;
  name: string;
  app_short_name: string;
  app_logo: string;
  link: string;
}

export default defineComponent({
  name: "KTAside",
  components: {
    KTMenu,
  },
  props: {
    lightLogo: String,
    darkLogo: String,
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();

    const sysVersion = process.env.VUE_APP_VERSION;

    const workspaceApps = ref<Array<WorkspaceApp>>([]);
    const hiddenLink = ref<null | HTMLElement>(null);
    const currentAppUrl = ref("");

    const getWorkspaceApps = async () => {
      const { data } = await ApiBase.getSsoApps({});
      if (data.code == 0) {
        workspaceApps.value = data.data;
      }
    };

    const onAppClick = async (url) => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      const { data } = await ApiBase.getSsoAppUrl(url, {});
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      if (data.code == 0) {
        currentAppUrl.value = data.data.app_sso_url;
        await nextTick();
        if (hiddenLink.value) {
          hiddenLink.value.click();
        }
      }
    };

    const hideOtherDropdowns = () => {
      MenuComponent.hideDropdowns(undefined);
    };

    const handleMouseLeave = () => {
      hideOtherDropdowns();
    };

    onMounted(() => {
      getWorkspaceApps();
      ToggleComponent.reinitialization();
      MenuComponent.reinitialization();
    });

    onUpdated(() => {
      ToggleComponent.bootstrap();
    });

    return {
      asideTheme,
      sysVersion,
      t,
      workspaceApps,
      currentAppUrl,
      hiddenLink,
      onAppClick,
      hideOtherDropdowns,
      handleMouseLeave,
    };
  },
});
